"use client";

import React, { useCallback, useEffect } from "react";
import { Control, FieldValues, Path, useController } from "react-hook-form";
import { UnitAvailabilityPage } from "../calendar";
import { Slot } from "../calendar/availabilities";
interface UnitAvailabilityInputProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  unitId?: string;
  sellerUnitId?: string;
  handleChange?: () => void;
}
export function UnitAvailabilityInput<T extends FieldValues>({
  name,
  control,
  unitId,
  sellerUnitId,
  handleChange
}: UnitAvailabilityInputProps<T>) {
  const {
    field: {
      value,
      onChange
    },
    fieldState: {
      error
    }
  } = useController({
    name,
    control
  });
  const [defaultSlot, setDefaultSlot] = React.useState<Slot[]>(value || []);
  useEffect(() => {
    setDefaultSlot(value || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle slot selection from the calendar

  // Handle slot selection from the calendar
  const handleSlotSelect = useCallback((slots: Array<{
    startTime: Date;
    endTime: Date;
  }>) => {
    // Ensure all slots have valid Date objects
    const validatedSlots = slots.filter(slot => slot.startTime instanceof Date && slot.endTime instanceof Date && !isNaN(slot.startTime.getTime()) && !isNaN(slot.endTime.getTime()));

    // For each validated slot, check if it exists in defaultSlot
    const updatedSlots = [...defaultSlot];
    validatedSlots.forEach(vs => {
      const existingIndex = updatedSlots.findIndex(ds => new Date(ds.startTime).getTime() === new Date(vs.startTime).getTime() && new Date(ds.endTime).getTime() === new Date(vs.endTime).getTime());
      if (existingIndex !== -1) {
        // Slot exists, remove it
        updatedSlots.splice(existingIndex, 1);
      } else {
        // Slot doesn't exist, add it
        updatedSlots.push(vs);
      }
    });
    onChange(updatedSlots);
    handleChange?.();
  }, [defaultSlot, onChange, handleChange]);
  return <div className="w-full">
			<UnitAvailabilityPage unitId={unitId} sellerUnitId={sellerUnitId} onSlotSelect={handleSlotSelect} selectedSlots={value || []} />
			{error && <div className="text-sm font-medium text-destructive">{error.message}</div>}
		</div>;
}